import { ConfigForm } from '@/common/entities/config/ConfigForm';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';

export const ConfigDetail = () => {
  const { entityObj } = useEntityMgr();

  return (
    <EntityDetail>
      <ConfigForm entityId={entityObj.id} />
    </EntityDetail>
  );
};
